import { FC } from "react";
import { Platform } from "react-native";
import { Country, Locale } from "@lookiero/sty-psp-locale";
import { SentryEnvironment } from "@lookiero/sty-psp-logging/sentry";
import { Segment } from "@lookiero/sty-psp-segment";
import { themeByTradename } from "@lookiero/sty-psp-ui";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { devSettings } from "./devSettings";
import { KameleoonEnvironment } from "./infrastructure/ab-testing/kameleoonEnvironment";
import { bootstrap as styleProfileBootstrap } from "./infrastructure/delivery/bootstrap";
import { Customer } from "./projection/customer/customer";
import { isNativeTestVariant, mockServerApiUrl } from "./testVariant/nativeTestVariant";
import { RELEASE } from "./version";

const styleProfileSentryConfig: SentryEnvironment = {
  publicKey: "bf9ded71e97254c526526bf5cc878aa1",
  release: RELEASE,
  project: "4506121843048448",
  environment: "development",
  dist: "web-standalone",
};

const apiUrl = isNativeTestVariant
  ? mockServerApiUrl
  : Platform.OS !== "web"
    ? "https://web2.sp.dev.aws.lookiero.es/style-profile/api"
    : __DEV__
      ? process.env.EXPO_PUBLIC_CI
        ? "/local-to-dev"
        : "http://localhost:3001/local-to-dev"
      : "/style-profile/api";

const tradename = Tradename.LOOKIERO;
const theme: ReturnType<typeof themeByTradename> = themeByTradename({ tradename });
const locale: Locale = devSettings?.locale ?? Locale.es_ES;
const CUSTOMER: Record<Tradename, Customer> = {
  [Tradename.LOOKIERO]: {
    customerId: "0004a049-fef6-4bac-a45d-b3a904b4ee4b",
    country: Country.ES,
    segment: Segment.WOMEN,
  },
  [Tradename.OUTFITTERY]: {
    customerId: "598005b4-bc04-4d38-b1e1-0b92706f496a",
    country: Country.ES,
    segment: Segment.MEN,
  },
};
const customer = CUSTOMER[tradename];

const kameleoonConfig: KameleoonEnvironment = {
  siteCode: "aplm4v3ckn",
  experiments: {
    nextBestAction: {
      id: "262141",
      variations: {
        v1: "1004339",
      },
    },
  },
};

interface RootProps {
  readonly customer: Customer;
  readonly tradename: Tradename;
  readonly locale: Locale;
  readonly getAuthToken: () => Promise<string>;
}
type Root = FC<RootProps>;

export type { Root };
export {
  apiUrl,
  customer,
  CUSTOMER,
  kameleoonConfig,
  locale,
  styleProfileBootstrap,
  styleProfileSentryConfig,
  theme,
  tradename,
};
